import React from 'react';

const USERNAME = 'ekkovats';
const PROFILE_URL = `https://github.com/${USERNAME}`;

// Static, dependency-free GitHub card. Nothing to fetch, so nothing to break
// over time — it always links to the live profile where the real graph lives.
const GithubActivity = () => (
    <section id="github" className="section">
        <div className="container">
            <p className="eyebrow">06 — GitHub</p>
            <div className="gh-head">
                <h2 className="section-title">GitHub</h2>
                <a href={PROFILE_URL} target="_blank" rel="noreferrer" className="project-link">
                    @{USERNAME} <span aria-hidden="true">→</span>
                </a>
            </div>
            <a href={PROFILE_URL} target="_blank" rel="noreferrer" className="gh-card">
                <span className="gh-card-title">View my contributions on GitHub</span>
                <span className="gh-card-sub">
                    Live contribution graph, repositories, and activity → github.com/{USERNAME}
                </span>
            </a>
        </div>
    </section>
);

export default GithubActivity;
